module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            message: '=',
            messageIndex: '='
        },
        link($scope) {
            $scope.dismissed = false;

            $scope.dismissMessage = function () {
                $scope.dismissed = true;
            };

            $scope.showMessage = function () {
                return !$scope.dismissed;
            };
        },
        template: require('./collection-zone-message-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-message-directive.js
 **/